import React, { Component } from 'react';
import * as yup from "yup";
import { DatePicker, message, Radio, Space } from 'antd';
import { isEmpty } from 'lodash';
import map from 'lodash/map';
import moment from 'moment-timezone';
import { Layout, Sidebar } from '../Common/Component';

import trash from '../../Assets/images/trash.svg';
import Upload_Photo from '../../Assets/images/Upload_Photo.svg';
import {aboutUsData} from "../../Assets/data/aboutUsList";

class DogInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      service_order_data: {},
      has_doggy_door: null,
      is_dogs_outside: null,
      can_clean_if_dogs_out: null,
      is_footer: false,
      is_show_summary: false,
      pets: [],
      hear_about_us: [],
      errors: {},
      contactUsData: aboutUsData,
      test: null
    }
  }

  componentDidMount = () => {
    const localOrderSubmit = JSON.parse(sessionStorage.getItem('orderSubmit'));

    if (Object.keys(this.props.pricingCalc).length) {
      sessionStorage.setItem('couponInfoNeededFromPricingCalc', JSON.stringify(this.props.pricingCalc));
    }

    if (Object.keys(this.props.orderSubmit).length) {
      sessionStorage.setItem('orderSubmit', JSON.stringify(this.props.orderSubmit));

      const { pets } = this.state;
      this.setState({ service_order_data: this.props.orderSubmit });

      const pet_counts = this.props.orderSubmit.calculated_price.pet_count;
      for (let index = 0; index < pet_counts; index++) {
        pets.push({
          name: '',
          breed: '',
          birthday: null,
          is_friendly: false,
          can_treat: false,
          additional_info: '',
          photo: ''
        })
      }

      this.setState({ pets });
    } else if (localOrderSubmit && Object.keys(localOrderSubmit).length) {
      const { pets } = this.state;
      this.setState({ service_order_data: localOrderSubmit });

      const pet_counts = localOrderSubmit.calculated_price.pet_count;
      for (let index = 0; index < pet_counts; index++) {
        pets.push({
          name: '',
          breed: '',
          birthday: null,
          is_friendly: false,
          can_treat: false,
          additional_info: '',
          photo: ''
        })
      }

      this.setState({ pets });
    } else {
      window.location.assign('/')
    }
    // Hey, a popstate event happened!
    window.addEventListener("popstate", () => {
      window.location.assign('/')
    })

    const emailToCheck = (localOrderSubmit && localOrderSubmit.email) || (this.props.orderSubmit && this.props.orderSubmit.email);

    if (emailToCheck) {
      // this.props.checkEmail(emailToCheck)
    }

    var self = this;
    setTimeout(() => {
      this.updateDimensions();
      window.addEventListener("resize", self.updateDimensions.bind(self));

    }, 500);

    if (window.innerWidth <= 500) {
      this.setState({
        is_show_summary: true,
      })
    }
    else {
      this.setState({
        is_footer: true,
      })
    }

    const is_overview = JSON.parse(sessionStorage.getItem('is_lead'));
    const is_new = JSON.parse(sessionStorage.getItem('is_new'));
    const first_selected = is_overview === "true" || is_new === "true" ? sessionStorage.getItem('hear_about_us') : JSON.parse(sessionStorage.getItem('hear_about_us'));

    if(first_selected)
    {
      this.setState({hear_about_us: [first_selected]});
    }
  }

  // Calculate dimensions
  updateDimensions() {
    var self = this;
    if (window.innerWidth <= 500) {
      //true
      self.setState({
        is_footer: true,
      })

    }
    else {
      self.setState({
        is_footer: false,
        is_show_summary: false
      })
    }
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    const userKey = JSON.parse(localStorage.getItem("userKey"))
      ? JSON.parse(localStorage.getItem("userKey")).key
      : "";
      
    if (Object.keys(props.orderUpdate.data).length > 0) {
      this.props.updateCustomerLastCompletedStep({
        step: 5,
        tracking_uuid: JSON.parse(sessionStorage.getItem("tracking_uuid"))
      });

      let emailInUse = JSON.parse(sessionStorage.getItem('emailInUse'))
      if (emailInUse) {
        if (userKey) {
          this.props.history.push('/account')
        }
        else {
          this.props.history.push('/login', { email: this.state.service_order_data.email })
        }

      } else {
        this.props.history.push('/registration', { allowRegistration: true })
      }
    }

    if (Object.keys(props.orderUpdate.errors).length > 0 && props.orderUpdate.errors !== this.props.orderUpdate.errors) {
      if (props?.orderUpdate?.errors?.detail) {
        message.error(props?.orderUpdate?.errors?.detail);
      }
    }

    this.setState({ loader: false });
  }

  // Safety Information
  onSafetyChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  // Dog Profile pic upload
  onDogImagesChange = (e, id) => {
    const pets = [...this.state.pets];
    const reader = new FileReader();
    reader.onloadend = function () {
      pets[id]['photo'] = reader.result;
    }
    reader.readAsDataURL(e.target.files[0]);

    setTimeout(() => {
      this.setState({ pets })
    }, 100);
  }
  // set Dog details
  onPetChange = (e, id) => {
    const pets = [...this.state.pets];
    const name = e.target.name.split("-")[0];
    pets[id][name] = e.target.value;

    this.setState({ pets });
  }

  // on birthday change
  onBirthdayChange = (e, i) => {
    const {pets} = this.state;
    const value = e.target.value;
    let new_value = value;

    if (value?.length === 2) {
      new_value = value + '/'
    } else if (value?.length === 5) {
      new_value = value + '/'
    }

    Object.assign(pets[i], {birthday: new_value});
    this.setState({pets});
  }

  // on birthday key press event
  onBirthdayKeyPress = (e, i) => {
    const {pets} = this.state;
    const birthday = pets[i].birthday
    const value = e.key;

    if (value === "Backspace") {
      if (birthday.substr(birthday?.length - 1, 1) === '/') {
        e.preventDefault()
        Object.assign(pets[i], {birthday: birthday.substr(0, birthday?.length - 1)})
        this.setState({pets})
      }
    }
  }

  // About your Dogs
  RenderDogList = () => {
    let {
      pets,
      errors
    } = this.state;

    return map(pets, (item, i) => {
      return (
        <div className="dog_info_grid" key={i}>
          <div className="dog_info_wrpper">
            <div className="info_box">
              <div className="billing_control mb-2">
                <div className="multi_control">
                  <input type="text"
                    maxLength={15}
                    name={'name-' + i}
                    value={pets[i].name}
                    placeholder="Dog Name"
                    className="form--control"
                    onChange={(e) => { this.onPetChange(e, i) }}
                  />

                  <img src={trash}
                    alt=""
                    className="delete_dod_info"
                    onClick={() => {
                      // clear data 
                      pets[i]['name'] = ''
                      pets[i]['breed'] = ''
                      pets[i]['birthday'] = null
                      pets[i]['additional_info'] = ''
                      pets[i]['photo'] = ''
                      pets[i]['is_friendly'] = null
                      pets[i]['can_treat'] = null
                      this.setState({ pets })
                    }}
                  />

                </div>
                {errors?.[`pet_${i}`]?.name ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`pet_${i}`]?.name}</label> : ''}

              </div>
              <div className="billing_control">
                <input type="text"
                  maxLength={15}
                  name={'breed-' + i}
                  placeholder="Breed"
                  value={pets[i].breed}
                  className="form--control"
                  onChange={(e) => { this.onPetChange(e, i) }}
                />
                {errors?.[`pet_${i}`]?.breed ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`pet_${i}`]?.breed}</label> : ''}
              </div>
              <div className="billing_control">
                <div className="multi_control datepicker_multi_control">
                  <div className={'flex pos-relative'}>
                    <input
                      type={'text'}
                      placeholder={'Birthday MM/DD/YYYY'}
                      maxLength={10} value={pets[i]['birthday'] || ''}
                      onChange={(e) => this.onBirthdayChange(e, i)}
                      onKeyDown={(e) => this.onBirthdayKeyPress(e, i)}
                      className="form--control"
                    />
                    <div className={"only-icon-datepick"}>
                      <DatePicker
                        disabledDate={(current) => {
                          return current && current > moment().endOf("day");
                        }}                       
                        format="MM/DD/YYYY"
                        inputReadOnly
                        value={pets[i]['birthday'] && moment(pets[i]['birthday'], 'MM/DD/YYYY')}
                        onChange={(e) => {
                          pets[i]['birthday'] = e.format('MM/DD/YYYY');
                          this.setState({ pets })
                        }}
                        allowClear={false}
                        dropdownClassName="dog_date_dropdown"
                        placeholder="Birthday MM/DD/YYYY" />
                    </div>
                  </div>

                  {pets[i]['photo'] ?
                    <div className="dog_image">
                      <img src={pets[i]['photo']} className="profile_pic " alt="" />
                      <i className="las la-times-circle remove_images" onClick={() => { pets[i]['photo'] = ''; this.setState({ pets }) }}></i>
                    </div>
                    :
                    <React.Fragment>
                      <div className="upload-btn-wrapper">
                        <button className="upload_btn"><img src={Upload_Photo} alt="" /></button>
                        <input type="file" name={'photo-' + i} onChange={(e) => { this.onDogImagesChange(e, i) }} />
                      </div>
                    </React.Fragment>
                  }
                </div>
                {errors?.[`birthday`]?.[i] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors[`birthday`][i]}</label> : ''}
              </div>
              <div className="multi_control radio-duo radio-group">
                <label>Is this dog friendly?</label>
                <Radio.Group
                  id={`is_friendly_${i}`}
                  name={`is_friendly_${i}`}
                  style={{ display: "flex", flexDirection: "row" }}
                  value={pets[i]['is_friendly_dog']}
                  onChange={(e) => {
                    pets[i]['is_friendly_dog'] = e.target.value;
                    pets[i]['is_friendly'] = e.target.value === "yes" ? true : false;
                    this.setState({ pets });
                  }}
                >
                  <Space direction="horizontal" style={{alignItems:" flex-start"}}>
                    <Radio className="billing_radio" value={"yes"}>
                      Yes
                    </Radio>
                    <Radio className="billing_radio" value={"no"}>
                      No
                    </Radio>
                  </Space>
                </Radio.Group>
              </div>
              {errors?.[`pet_${i}`]?.is_friendly_dog ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`pet_${i}`]?.is_friendly_dog}</label> : ''}

              <div className="multi_control radio-duo radio-group">
                <label> Can we give this dog a treat?</label>
                <Radio.Group
                  id={`can_treat_${i}`}
                  name={`can_treat_${i}`}
                  style={{ display: "flex", flexDirection: "row" }}
                  value={pets[i]['can_treat_dog']}
                  onChange={(e) => {
                    pets[i]['can_treat_dog'] = e.target.value;
                    pets[i]['can_treat'] = e.target.value === "yes" ? true : false;
                    this.setState({ pets });
                  }}
                >
                  <Space direction="horizontal" style={{alignItems:" flex-start"}}>
                    <Radio className="billing_radio" value={"yes"}>
                      Yes
                    </Radio>
                    <Radio className="billing_radio" value={"no"}>
                      No
                    </Radio>
                  </Space>
                </Radio.Group>
              </div>
              {errors?.[`pet_${i}`]?.can_treat_dog ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`pet_${i}`]?.can_treat_dog}</label> : ''}

              <div className="billing_control  mb-0">
                <textarea className="form--control text-area--control"
                  value={pets[i]['additional_info']}
                  name="additional_info" rows="40" cols="50"
                  placeholder="Additional Information"
                  onChange={(e) => { this.onPetChange(e, i) }} />
              </div>
            </div>
          </div>
        </div>
      )
    })
  }

  // How did you hear about us
  hearAboutUsChange = (e) => {
    const { hear_about_us } = this.state;
    if (e.target.checked) {
      hear_about_us.push(e.target.value)
    }
    else {
      const index = hear_about_us.indexOf(e.target.value);
      if (index > -1) {
        hear_about_us.splice(index, 1);
      }
    }

    this.setState({ hear_about_us });
  }

  validate = async (e) => {
    let {
      pets,
      errors,
      has_doggy_door,
      is_dogs_outside,
      can_clean_if_dogs_out
    } = this.state;
    let isValidDate = [],
      errors_object = {},
      birthday = new Array(pets.length)
    ;

    const general_schema = yup.object().shape({
      has_doggy_door: yup.string().required("Please make a selection."),
      is_dogs_outside: yup.string().required("Please make a selection."),
      can_clean_if_dogs_out: yup.string().required("Please make a selection."),
    });

    const schema = yup.object().shape({
      name: yup.string().required("Please enter a dog name.").max(15),
      breed: yup.string().required("Please enter the breed.").max(15),
      can_treat_dog: yup.string().required("Please make a selection."),
      is_friendly_dog: yup.string().required("Please make a selection."),
    });

    await map(pets, (item, i) => {
      isValidDate[i] = item?.birthday ? ( moment(item?.birthday).isValid() && (moment(item?.birthday) <= moment().endOf('day')) ) : true;

      schema.validate(item, { abortEarly: false })
      .then(() => {})
      .catch((error) => {
        if(error.errors.length > 0)
        {
          let mapped_pet_errors = error.inner.map( item => {
            return { [item.params?.path]: item.message }
          });
  
          mapped_pet_errors.forEach(item => {Object.assign(errors_object, item)});
          Object.assign(errors, {[`pet_${i}`]: errors_object});

          this.setState({errors});
        }
      });
    });

    const data = {
      has_doggy_door,
      is_dogs_outside,
      can_clean_if_dogs_out
    };

    await general_schema.validate(data, { abortEarly: false })
    .then(() => {})
    .catch((error) => {
      if(error.errors.length > 0)
      {
        console.log(error);

        error.inner.forEach( item => {
          errors = Object.assign(errors, {[item.params?.path]: "Please make a selection"});
        });

        this.setState({errors});
      }
    });
    
    if (isValidDate.includes(false))
    {
      let idx = isValidDate.indexOf(false);
      birthday[idx] = 'Invalid date';

      Object.assign(errors, {birthday});
      this.setState({errors});
    }

    if(Object.keys(errors).length === 0 && Object.keys(errors_object).length === 0)
    {
      this.setState({errors: {}}, () => this.serviceOrderPlace(e));
    }
  }
  
  // Call service order api
  serviceOrderPlace = (e) => {
    e.preventDefault();
    const {
      has_doggy_door, 
      is_dogs_outside,
      can_clean_if_dogs_out,
      hear_about_us,
      pets,
      service_order_data
    } = this.state;

    map(pets, (item, i) => {
      pets[i] = Object.assign(pets[i], {
        'has_doggy_door': has_doggy_door,
        'can_clean_if_in_yard': can_clean_if_dogs_out,
        birthday: item.birthday ? moment(item?.birthday).format('YYYY-MM-DD') : null
      });
    });

    const data = {
      is_dogs_outside: is_dogs_outside === "no" ? false : true,
      pets,
      hear_about_us,
      has_doggy_door: has_doggy_door === "no" ? false : true,
      can_clean_if_dogs_out: can_clean_if_dogs_out === "no" ? false : true,
      outreach: "website"
    }

    // Call  update order api
    this.setState({ loader: true });
    
    if (this.isLoggedIn()) {
      this.props.updateOrder(data, service_order_data.uuid);
    } else {
      this.props.updateOrderInquery(data, service_order_data.uuid);
    }
  }

  isLoggedIn = () => {
    // Get userKey from local storage and check if it is not empty
    try {
      const userKey = localStorage.getItem('userKey');
      if (!isEmpty(JSON.parse(userKey))) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  // Multi value select
  onMultipleOptionChecked = (e, name) => {
    const { hear_about_us } = this.state;
    const data = name === 'hear_about_us' ? hear_about_us : [];
    const idx = data.indexOf(e.target.value);

    if (e.target.checked) {
      idx === -1 && data.push(e.target.value);
    } else {
      idx > -1 && data.splice(idx, 1);
    }
    this.setState({ [name]: data });
  };

  //Render hear about us
  renderContactUs = (item, index) => {
    const { hear_about_us } = this.state;
    const isSelected = hear_about_us?.indexOf(item.value) > -1;

    return (
      <label htmlFor={item.id} className={isSelected ? "area_box active_area_box" : "area_box"} key={`Type${index}`}>
        <span>{item.name}</span>
        <input 
          type="checkbox"
          id={item.id}
          name='hear_about_us'
          className="custom--checkbox"
          value={item.value}
          onChange={(e) => this.onMultipleOptionChecked(e, 'hear_about_us')}
        />
      </label>
    )
  };

  render() {
    const {
      loader,
      errors,
      is_footer,
      contactUsData,
      has_doggy_door,
      is_show_summary,
      is_dogs_outside,
      service_order_data,
      can_clean_if_dogs_out,
    } = this.state;
    const pricingCalc = Object.keys(this.props.pricingCalc).length ? this.props.pricingCalc : JSON.parse(sessionStorage.getItem('couponInfoNeededFromPricingCalc'));

    if (Object.keys(service_order_data).length === 0) {
      return (<div />);
    }

    return (
      <Layout noFooter={is_footer}>
        <div className="page_inner_content">
          <div className="dog_details_wrapper">
            <div className="container">
              <div className="row">
                {!is_show_summary ?
                  <div className="col-md-7">
                    <section className="safety_info">
                      <h1>Dog and Safety Information</h1>
                      <div className="page_heading">
                        <h2>Safety Information</h2>
                        <p>Tell us about your dogs.</p>
                      </div>
                      <ul className="safety_list">
                        <li style={{display: "flex", flexFlow: "column"}}>
                          <div className="multi_control radio-duo radio-group">
                            <label>Is there a doggy door?</label>
                            <Radio.Group
                              name="has_doggy_door"
                              style={{ display: "flex", flexDirection: "row" }}
                              value={has_doggy_door}
                              onChange={(e) => this.onSafetyChange(e)}
                            >
                              <Space direction="horizontal">
                                <Radio className="billing_radio" value={"yes"}>
                                  Yes
                                </Radio>
                                <Radio className="billing_radio" value={"no"}>
                                  No
                                </Radio>
                              </Space>
                            </Radio.Group>
                          </div>
                          {errors?.[`has_doggy_door`] ? <label className="new_err_msg" style={{justifySelf: "flex-start", width: "100%"}}><i className="las la-info-circle" />{errors?.[`has_doggy_door`]}</label> : ''}
                        </li>

                        <li style={{display: "flex", flexFlow: "column"}}>
                          <div className="multi_control radio-duo radio-group">
                            <label>Are your dogs left outside when no one is home?</label>
                            <Radio.Group
                              name="is_dogs_outside"
                              style={{ display: "flex", flexDirection: "row" }}
                              value={is_dogs_outside}
                              onChange={(e) => this.onSafetyChange(e)}
                            >
                              <Space direction="horizontal">
                                <Radio className="billing_radio" value={"yes"}>
                                  Yes
                                </Radio>
                                <Radio className="billing_radio" value={"no"}>
                                  No
                                </Radio>
                              </Space>
                            </Radio.Group>
                          </div>
                          {errors?.[`is_dogs_outside`] ? <label className="new_err_msg" style={{justifySelf: "flex-start", width: "100%"}}><i className="las la-info-circle" />{errors?.[`is_dogs_outside`]}</label> : ''}
                        </li>

                        <li style={{display: "flex", flexFlow: "column"}}>
                          <div className="multi_control radio-duo radio-group">
                            <label>Can we clean with the dogs in the yard?</label>
                            <Radio.Group
                              name="can_clean_if_dogs_out"
                              style={{ display: "flex", flexDirection: "row" }}
                              value={can_clean_if_dogs_out}
                              onChange={(e) => this.onSafetyChange(e)}
                            >
                              <Space direction="horizontal">
                                <Radio className="billing_radio" value={"yes"}>
                                  Yes
                                </Radio>
                                <Radio className="billing_radio" value={"no"}>
                                  No
                                </Radio>
                              </Space>
                            </Radio.Group>
                          </div>
                          {errors?.[`can_clean_if_dogs_out`] ? <label className="new_err_msg" style={{justifySelf: "flex-start", width: "100%"}}><i className="las la-info-circle" />{errors?.[`can_clean_if_dogs_out`]}</label> : ''}
                        </li>
                      </ul>
                    </section>
                    <div className="border_bottom_end"></div>
                    <section className="about_dog">
                      <h2>About your Dogs</h2>
                      <div className="row">

                        {this.RenderDogList()}

                      </div>
                    </section>
                    <div className="border_bottom_end"></div>

                    <hr />
                    <div className="hear_about_us">
                      <h2 className="headlabel">How did you hear about us? <small>(select all that apply)</small></h2>
                      <div className="hear_about_us_wrapper">
                        {
                          contactUsData?.map(this.renderContactUs)
                        }
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 text-right">
                        <button
                          type="button"
                          className="btn btn--secondary service_order_btn"
                          onClick={(e) => {
                            this.setState({errors: {}}, () => this.validate(e));
                          }}
                        >Update</button>
                      </div>
                    </div>
                  </div>
                  : ''}
                <div className="col-md-1 d-lg-block d-md-none"></div>
                <div className={is_footer ? 'col-md-5 col-lg-4 p-0' : 'col-md-5 col-lg-4'}>
                  <Sidebar
                    service_order_data={service_order_data}
                    pricingCalc={pricingCalc}
                    is_footer={is_footer}
                    is_show_summary={is_show_summary}
                  />
                  {is_show_summary && is_footer ?
                    <React.Fragment>
                      <div className="sidebar_note">
                        <p>Questions about your quote? <a href="https://www.doodycalls.com/contact-us/">Request more information, chat</a> or call us at 1-800-366-3922 and we’ll walk you through it. We are available Mon-Fri from 8AM to 9PM EST and Saturday and Sunday from 12PM - 5PM EST.</p>
                      </div>
                      <div className="submit_btn mobile_continue_btn">
                        <button type="button" onClick={() => { this.setState({ is_show_summary: false }); window.scrollTo(0, 0); }} className="btn">Update profile</button>
                      </div>
                    </React.Fragment>
                    : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
        {loader && <div className="loader_wrapper">
          <div className="loader07"></div>
        </div>}
      </Layout>
    );
  }
}

export default DogInfo;